import { Link, NavLink } from 'react-router-dom';
import { LangToggle } from './LangToggle';
import { ThemeToggle } from './ThemeToggle';
import { useQuizLang } from '../lib/quizLang';

interface HeaderProps {
  online?: number;
}

const NAV_LABELS = {
  ru: { games: 'Игры', quizzes: 'Квизы', rooms: 'Комнаты', mafia: 'Мафия' },
  en: { games: 'Games', quizzes: 'Quizzes', rooms: 'Rooms', mafia: 'Mafia' },
} as const;

export function Header({ online }: HeaderProps) {
  const [lang] = useQuizLang();
  const labels = NAV_LABELS[lang];

  return (
    <header className="bar">
      <div className="bar-row">
        <Link to="/" className="logo">
          <span className="logo-mark">Ш</span>
          <span className="logo-name">Шум.клуб</span>
        </Link>
        <nav className="nav">
          <NavLink to="/" className={({ isActive }) => (isActive ? 'on' : '')} end>
            {labels.games}
          </NavLink>
          <NavLink to="/quizzes" className={({ isActive }) => (isActive ? 'on' : '')}>
            {labels.quizzes}
          </NavLink>
          <NavLink to="/rooms" className={({ isActive }) => (isActive ? 'on' : '')}>
            {labels.rooms}
          </NavLink>
          <NavLink to="/play/mafia" className={({ isActive }) => (isActive ? 'on' : '')}>
            {labels.mafia}
          </NavLink>
        </nav>
        <div className="bar-actions">
          <LangToggle />
          <ThemeToggle />
          {online ? (
            <span className="pill">
              <span className="dot" />
              {online.toLocaleString('ru-RU')} {lang === 'ru' ? 'онлайн' : 'online'}
            </span>
          ) : null}
        </div>
      </div>
    </header>
  );
}
